import React, { Component } from "react";
import { Row, Col, Container } from "reactstrap";
import { inyectionTrinidad } from "../../../redux/actions/SpiderActions";
import { connect } from "react-redux";
import Sad from "../../../shared/assets/sad.svg";

class Error extends Component {

  constructor(props) {
    super(props);
    this.message = (props.trinidad.return.message) || "";
    this.state = {};
  }

  render() {
    return (
      <Container>
        <Row>
          <Col md={8} className="offset-md-2 ">
            <div className="card-shadow p-4 text-center">
              <div>
                <img src={Sad} alt='' style={{ height: "9rem", marginTop: "16px" }} />
              </div>

              <div
                className="mt-4"
                style={{
                  fontSize: "1.5rem",
                  color: "#000000",
                  fontWeight: "bold",
                }}
              >
                Lo sentimos, ha ocurrido un error
              </div>

              <div
                className="mt-2"
                style={{
                  fontSize: "1rem",
                  color: "#000000",
                  fontWeight: "400",
                }}
              >
                  Quizas esto te ayude a solucionarlo:
                  <b>{this.message}</b> Por favor inténtelo nuevamente más tarde
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  trinidad: state.spider.trinidad,
});

const mapDispatchToProps = {
  inyectionTrinidad,
};
export default connect(mapStateToProps, mapDispatchToProps)(Error);
